import api from './api';

export const EVENT_TYPES = [
    { value: 'celebracion', label: 'Celebración', icon: '🎉', color: 'bg-pink-100 text-pink-700' },
    { value: 'cumpleanos', label: 'Cumpleaños', icon: '🎂', color: 'bg-pink-100 text-pink-700' },
    { value: 'evento', label: 'Evento', icon: '📅', color: 'bg-indigo-100 text-indigo-700' },
    { value: 'viaje', label: 'Viaje', icon: '✈️', color: 'bg-cyan-100 text-cyan-700' },
    { value: 'medico', label: 'Médico', icon: '🏥', color: 'bg-blue-100 text-blue-700' },
    { value: 'salud', label: 'Salud', icon: '❤️', color: 'bg-rose-100 text-rose-700' },
    { value: 'escolar', label: 'Escolar', icon: '🎓', color: 'bg-indigo-100 text-indigo-700' },
    { value: 'trabajo', label: 'Trabajo', icon: '💼', color: 'bg-amber-100 text-amber-700' },
    { value: 'pago', label: 'Pago', icon: '💳', color: 'bg-emerald-100 text-emerald-700' },
];

export const RECURRENCE_OPTIONS = [
    { value: 'daily', label: 'Diario' },
    { value: 'weekly', label: 'Semanal' },
    { value: 'monthly', label: 'Mensual' },
    { value: 'yearly', label: 'Anual' },
];

export function eventTypeMeta(type) {
    return EVENT_TYPES.find((t) => t.value === type) || EVENT_TYPES[2];
}

export async function listEvents(from, to, type) {
    const params = {};
    if (from) params.from = from;
    if (to) params.to = to;
    if (type) params.type = type;
    const r = await api.get('/events', { params });
    return r.data;
}
export async function fetchEvent(id) {
    const r = await api.get(`/events/${id}`);
    return r.data.event;
}
export async function createEvent(payload) {
    const r = await api.post('/events', payload);
    return r.data.event;
}
export async function updateEvent(id, payload) {
    const r = await api.patch(`/events/${id}`, payload);
    return r.data.event;
}
export async function deleteEvent(id) {
    await api.delete(`/events/${id}`);
}
export async function upcomingEvents(days = 30) {
    const r = await api.get('/events/upcoming', { params: { days } });
    return r.data.events || [];
}
